import styled, { css } from 'styled-components/macro';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { Z_INDEX } from '@yme/tokens/zindex';
export const FavoriteButton = styled.button `
  display: block;
  position: absolute;
  right: 0;
  cursor: pointer;
  top: 0;
  z-index: ${Z_INDEX.level1};
  padding: 8px;
  border: 0;
  background-color: transparent;

  svg g path {
    transition: all 0.1s ease-in;
  }

  ${({ isBusy }) => isBusy &&
    css `
      cursor: progress;
    `}

  ${({ isLiked }) => isLiked
    ? css `
          svg g path {
            fill: ${colorBrandYamahaRed};
            stroke: ${colorBrandYamahaRed};
          }
        `
    : css `
          :hover {
            svg g path {
              fill: ${colorBrandYamahaRed};
              stroke: ${colorBrandYamahaRed};
            }
          }
        `}
`;
